require('../../groupon-iframe-login/frontend/iframe_login');

Modules.EmailSubscription.Application = require('../../email_subscription/frontend/application');

require('./conquesting');

$(function() {
  var coupons, inlineSubscriptionForm, ref, ref1, ref2;
  $(document).on('click', '#sidebar .description-wrapper a.more', function() {
    var couponModal, description;
    couponModal = $('#merchantDescriptionModal');
    description = $(".full-description p").html();
    $("#merchantDescriptionModal p").html(description);
    GIG.Modal.open({
      el: couponModal
    });
    return false;
  });
  $('#sidebar a.show-more-related-stores').click(function() {
    $(this).toggle();
    return $('#sidebar div.more-related-stores').toggle();
  });
  $('#sidebar a.show-less-related-stores').click(function() {
    $('#sidebar div.more-related-stores').toggle();
    return $('#sidebar a.show-more-related-stores').toggle();
  });
  $('#sidebar a.show-more-popular-stores').click(function() {
    $(this).toggle();
    return $('#sidebar div.more-popular-stores').toggle();
  });
  $('#sidebar a.show-less-popular-stores').click(function() {
    $('#sidebar div.more-popular-stores').toggle();
    return $('#sidebar a.show-more-popular-stores').toggle();
  });
  if ($('.merchant-email-alert').attr('data-merchant-revenue-generating') === 'false') {
    coupons = $('.coupon');
    if (coupons.length > 2) {
      inlineSubscriptionForm = $('.merchant-email-alert');
      inlineSubscriptionForm.insertBefore(coupons[1]);
    }
  }
  setTimeout((function() {
    if ($('#sidebar .description-wrapper p.should-truncate').triggerHandler('isTruncated') === true) {
      $('#sidebar .description-wrapper a.more').show();
      return $('.full-description.description-wrapper').show();
    }
  }), 1000);
  if ((ref = Groupon.EmailSubscription) != null ? ref.enableCouponsEmailAlerts : void 0) {
    Modules.EmailSubscription.Application.initializeCouponsEmailAlerts();
  }
  if ((ref1 = Groupon.EmailSubscription) != null ? ref1.enableMerchantEmailAlerts : void 0) {
    Modules.EmailSubscription.Application.initializeMerchantEmailAlerts();
  }
  if ((ref2 = Groupon.Conquest) != null ? ref2.enableConquesting : void 0) {
    return Modules.Conquesting.Application.insertConquest();
  }
});

